export const DEFAULT_PAGE_SIZE_LIST = [10, 20, 50, 100];

/**
 *  @description 用來客製化的客戶統編
 */
export const SINOX_TAX_ID = "30847530";
